import { createContext } from 'react'

/** Home owns the gallery lightbox (rendered at the page root, as today); sections open it. */
export const ClassicHomeContext = createContext<{ openLightbox: (index: number) => void }>({ openLightbox: () => {} })
